import { useEffect, useRef } from "react";
import { reachGoal } from "@/utils/tracking";

const SCROLL_MILESTONES = [25, 50, 75, 100] as const;
const DEBOUNCE_DELAY = 200;

export const useScrollDepth = () => {
  const trackedMilestones = useRef<Set<number>>(new Set());
  const timeoutRef = useRef<NodeJS.Timeout>(undefined);

  useEffect(() => {
    const handleScroll = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        const scrollTop = window.scrollY;
        const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercentage = (scrollTop / documentHeight) * 100;

        for (const milestone of SCROLL_MILESTONES) {
          if (scrollPercentage >= milestone && !trackedMilestones.current.has(milestone)) {
            trackedMilestones.current.add(milestone);
            reachGoal(`scroll_${milestone}`, {
              depth: milestone,
              scrollTop,
              documentHeight,
            });
          }
        }
      }, DEBOUNCE_DELAY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
};
